import AbstractRequestTask from "../../AbstractRequestTask";
import {ENABLE_MODAL_RETRIES} from '../../../RequestManagerConstants';
import Device from "../../../../devices/device";

class activitiesTask extends AbstractRequestTask {
  constructor(params, gamificationId) {
    super();
    this.gamificationId = gamificationId;
    this.params = params;
  }

  getHeaders() {
    return {};
  }

  getParams() {
    const params = {}
    return Object.assign({}, params, this.params );
  }

  getUrl() {
    const device = Device.getDevice().getPlatform()
    const protocol = device === 'ps4' ? 'http://' : 'https://';
    const url = 'www.clarovideo.com';
    return `${protocol}${url}/api/social/activities/user/${this.gamificationId}`;
  }

  success(data, b) {
    if(data.status == true) this.resolve(data);  
    else this.reject(data);
  }

  isValid (data){
      return data && data.status == true || false;
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
  
}

export default activitiesTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/social/activities/activitiesTask.js